<template>
  <div
    class="viewcontent"
    v-if="
      translations.errors &&
        translations.event &&
        translations.buttons &&
        translations.info
    "
  >
    <form class="row mx-3 mb-3" @submit.prevent="processEvent()">
      <Alert type="warning" :list="errors.event"/>
      <Alert type="warning" :message="translations.info.event_activity" v-if="event.activity_num > 0"/>
      <div class="col-sm-6 col-xs-12">
        <label for="language" class="form-label w-100 my-3"
          >{{ translations.event.form_languages }}
          <span class="text-danger">*</span>
          <div v-if="checkDisabled" class="disabledmsg">
            {{ translations.errors.no_available_multiplelanguage }}
            <span class="disabledlink" @click="linkTo()">
              {{ translations.account.title_plan }}</span
            >
          </div>
          <SelectMultiple
            v-model="input.languages"
            :title="''"
            :values="languages"
            name="languages"
            class="selector"
            :filter="true"
            v-if="checkLanguageType"
            required
            :disabled="event.activity_num > 0"
          />
          <select
            name="languages"
            required
            class="form-control"
            v-model="input.language"
            @change="generateInputs"
            v-else
          >
            <option
              :value="item.value"
              v-for="(item, index) in languages"
              :key="index"
            >
              {{ item.text }}
            </option>
          </select>
        </label>
        <div v-if="input.languages">
          <div v-for="(item, index) in input.languages" :key="index">
            <label
              for="full_name"
              class="form-label w-100 my-3"
              v-for="(title, titleindex) in checkTitleLanguage(item)"
              :key="titleindex"
              ><span class="key"> [{{ item }}] </span>
              {{ translations.event.form_title }}
              <span class="text-danger">*</span>
              <input
                type="text"
                id="full_name"
                name="full_name"
                class="form-control"
                :placeholder="translations.placeholders.event_title"
                v-model="title.text"
                required
                :disabled="event.activity_num > 0"
              />
            </label>

            <label
              for="description"
              class="form-label w-100 my-3"
              v-for="(description,
              descriptionindex) in checkDescriptionLanguage(item)"
              :key="descriptionindex"
              ><span class="key"> [{{ item }}] </span>
              {{ translations.event.form_description }}
              <textarea
                rows="5"
                class="form-control"
                id="description"
                :placeholder="translations.placeholders.event_description"
                name="description"
                v-model="description.text"
                required
                :disabled="event.activity_num > 0"
              >
              </textarea>
            </label>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-xs-12">
        <label for="pictures" class="form-label w-100 my-3"
          >{{ translations.event.form_pictures }} (800x600px)
          <input
            type="file"
            accept=".jpg,.jpeg"
            id="pictures"
            name="pictures"
            class="form-control"
            @change="onPictureChange"
            multiple="multiple"
          />
        </label>

        <div class="col-12 p-4" v-if="event.edit_picture">
          <div class="col-12" v-if="preview">
            <img
              class="img-fluid img-thumbnail"
              :src="preview"
              :alt="event.title"
            />
          </div>
        </div>
        <div class="col-12 p-4" v-else-if="Array.isArray(event.pictures)">
          <div class="col-12">
            <img
              v-for="(item, index) in event.pictures"
              :key="index"
              class="img-fluid img-thumbnail"
              :src="files + item"
              :alt="event.title"
            />
          </div>
        </div>
        <label for="date_start" class="form-label w-50 my-3"
          >{{ translations.event.form_date_start }}
          <span class="text-danger">*</span>
          <input
            class="form-control"
            type="date"
            id="date_start"
            v-model="event.date_start"
            required
            :max="defineDateMax"
          /> </label
        ><label for="date_end" class="form-label w-50 my-3"
          >{{ translations.event.form_date_end }}
          <span class="text-danger" v-if="!checkDisabled">*</span>
          <div v-if="event.premium == 0" class="disabledmsg">
            {{ translations.errors.no_available }}

            <span class="disabledlink" @click="linkTo()">
              {{ translations.account.title_plan }}</span
            >
          </div>
          <input
            class="form-control"
            type="date"
            id="date_end"
            v-model="event.date_end"
            :class="disabledStyle"
            :min="defineDateMin"
            :disabled="checkDisabled"
            :required="!checkDisabled"
            :max="checkMax"
          />
        </label>
        <label for="eventurl" class="form-label w-100 my-3"
          >{{ translations.event.form_url }}
          <input
            class="form-control"
            type="text"
            id="eventurl"
            :placeholder="translations.placeholders.event_url"
            v-model="event.url"
          />
        </label>
        <label for="hashtags" class="form-label w-100 my-3">
          {{ translations.event.form_hashtags }}
          <input
            onkeydown="return /[a-z0-9\s]/i.test(event.key)"
            class="form-control"
            type="text"
            id="hashtags"
            :placeholder="translations.placeholders.event_hashtags"
            maxlength="50"
            v-model="event.hashtags"
          />
        </label>
        <label for="style" class="form-label w-100 my-3" v-if="checkType"
          >{{ translations.event.form_style }}
          <select
            class="form-select"
            id="style"
            name="style"
            v-model="event.style"
            v-if="checkType"
          >
            <option
              v-for="(item, index) in styles"
              :key="index"
              :value="item.id"
            >
              {{ item.full_name }}
            </option>
          </select>
        </label>
        <label for="districts" class="form-label w-100 my-3" v-if="checkType">
          {{ translations.event.form_districts }}
          <span class="text-danger">*</span>

          <textarea
            class="form-control"
            id="districts"
            required
            v-model="event.districts"
          ></textarea>
        </label>
      </div>
      <div class="col-12 pt-2">
        <button class="btn btn-danger mx-2" type="button" @click="cancel()">
          {{ translations.buttons.btn_exit }}
        </button>
        <input
          class="btn btn-primary mx-2"
          type="submit"
          :value="translations.buttons.btn_save"
        />
      </div>
    </form>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import SelectMultiple from '@/components/SelectMultiple.vue'
  import Alert from '@/components/atoms/Alert.vue' 
  export default {
    name: 'ToolEventEdit',
    components: {
      SelectMultiple,
      Alert
    },
    data() {
      return {
        edit: false,
        save_date_start: '',
        save_date_end: '',
        input: {
          languages: [],
          title: [],
          description: [],
        },
        preview: false,
        styles: [],
      }
    },
    computed: {
      ...mapState(['errors', 'event', 'files', 'languages', 'translations']),
      checkDisabled() {
        let result = true
        if (this.event.premium > 0) {
          result = false
        }
        return result
      },
      disabledStyle() {
        let clas = ''
        if (this.event.premium == 0) {
          clas = 'bg-disabled'
        }
        return clas
      },

      checkMax() {
        let ls = JSON.parse(localStorage.getItem('token'))
        return ls.plan_expiration
      },
      checkLanguageType() {
        let result = false
        if (this.event.premium > 0) {
          result = true
        }
        return result
      },
      checkType() {
        let ls = JSON.parse(localStorage.getItem('token'))
        let result = false
        if (ls.type == 2) {
          result = true
        }
        return result
      },
      defineDateMax() {
        let result = 0
        if (this.event && this.event.premium != 0) {
          result = this.event.date_end
        }
        if (this.event.activity_num > 0) {
          result = this.save_date_start
        }

        return result
      },
      defineDateMin() {
        let result = 0
        if (this.event && this.event.premium != 0) {
          result = this.event.date_start
        }
        if (this.event.activity_num > 0) {
          result = this.save_date_end
        }

        return result
      },
    },
    watch: {
      'input.languages'(to, from) {
        this.generateInputs()
      },
      translations(newT, oldT) {
        this.addTranslations()
      },
      'errors.event.length': function () {
        if (this.errors.event.length > 0) {
          this.$nextTick(() => {
            this.$el.querySelector('.alert').scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            })
          })
        }
      },
    },
    methods: {
      ...mapActions(['resetError', 'changeToolSelected', 'editEvent']),
      processEvent() {
        let ls = JSON.parse(localStorage.getItem('token'))

        this.event.title = JSON.stringify(this.input.title)
        this.event.description = JSON.stringify(this.input.description)
        this.event.languages = JSON.stringify(this.input.languages)
        this.editEvent(this.event)
      },
      linkTo() {
        this.changeToolSelected(null)

        router.push('/account')
      },
      onPictureChange(e) {
        let file = e.target.files
        this.event.pictures = file
        this.event.edit_picture = true

        if (e.target.files.length !== 0) {
          this.preview = URL.createObjectURL(file[0])
        }
      },
      checkTitleLanguage(language) {
        return this.input.title.filter((item) => item.key == language)
      },
      checkDescriptionLanguage(language) {
        return this.input.description.filter((item) => item.key == language)
      },
      cancel() {
        this.changeToolSelected(null)
      },
      async setInputs() {
        if (this.event.title && this.input.title.length <= 0) {
          this.input = {
            title: this.event.title,
            description: this.event.description,
          }

          if (this.input.title && this.input.title.length <= 0) {
            await this.generateInputs()
          }
        }
      },
      generateInputs() {
        if (this.input.language) {
          let save = [this.input.language]
          this.input.languages = save
        }
        if (this.input.languages && this.input.languages.length > 0) {
          for (let index = 0; index < this.input.languages.length; index++) {
            let found = false
            if (this.input.title) {
              found = this.input.title.some(
                (el) => el.key === this.input.languages[index]
              )
            }
            if (!found) {
              this.input.title.push({
                key: this.input.languages[index],
                text: '',
              })
              this.input.description.push({
                key: this.input.languages[index],
                text: '',
              })
            }
          }
        } else {
          this.input.title = []
          this.input.description = []
        }
      },
      async setInputs() {
        if (this.event.languages && this.input.languages.length <= 0) {
          this.input = {
            languages: Object.values(this.event.languages),
            title: this.event.title,
            description: this.event.description,
          }

          if (this.input.title && this.input.title.length <= 0) {
            await this.generateInputs()
          }
        }
      },
      addTranslations() {
        if (this.translations.styles) {
          this.styles = [
            {
              full_name: this.translations.styles.default,
              id: 'program_default.css',
            },
          ]
        }
      },
    },
    beforeUnmount() {
      this.resetError()
    },
    async created() {
      await this.setInputs()
      await this.generateInputs()
      if (!this.checkLanguageType) {
        this.input.language = this.event.languages[0]
      }
      this.addTranslations()
      if (this.event) {
        this.save_date_start = this.event.date_start
        this.save_date_end = this.event.date_end
      }
    },
  }
</script>

<style scoped>
  .key {
    text-transform: uppercase;
    font-weight: bold;
  }
  img {
    max-height: 200px;
  }
  .disabledmsg {
    font-size: 12px;
  }
  .disabledlink {
    font-weight: bold;
  }
  .disabledlink:hover {
    color: #ffc107;
  }
  .bg-disabled {
    background-color: #fffac0;
  }
</style>
